import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  apiUrl = environment.apiUrl;

  private _currentUser = this.apiUrl + '/user/current';
  user_full_name: any;
  user_name: any;
  user_type: any;
  profile_image: any;
  designation: string;
  durationFilterType: string;

  constructor(private http: HttpClient) {
  }

  setUserName(val: string) {
    this.user_name = val;
  }

  getUserName() {
    return this.user_name;
  }

  setUserFullName(val: string) {
    this.user_full_name = val;
  }

  getUserFullName() {
    return this.user_full_name;
  }

  setUserEmail(val: string) {
    this.user_type = val;
  }

  getUserEmail() {
    return this.user_type;
  }

  setUserType(val: string) {
    this.user_type = val;
  }

  getUserType() {
    return this.user_type;
  }

  setUserProfileImage(val: string) {
    this.profile_image = val;
  }

  getUserProfileImage() {
    return this.profile_image;
  }

  setUserDesignation(val: string) {
    this.designation = val;
  }

  getUserDesignation() {
    return this.designation;
  }

  setDurationFilterType(val: string) {
    this.durationFilterType = val;
  }

  getDurationFilterType() {
    return this.durationFilterType;
  }
}
